import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';
import { AuthService, User } from '../../../core/service/auth/auth.service';

// Le bandeau du haut ne porte QUE le nom de la page — pas de sous-titre (chaque écran a déjà son
// propre titre et sa propre explication dans son corps). Clé = `espace/section` : « paiements »
// n'a pas le même nom côté fédération (« Déclaration du club ») et côté club (« Paiements »), un
// simple dernier segment les confondrait. Les pages de détail (…/encaissements/:id) retombent sur
// leur section, donc sur le nom du parent.
const PAGE_TITLES: Record<string, string> = {
  'federation/dashboard': 'Tableau de bord',
  'federation/identite': 'Identité de la fédération',
  'federation/bareme': 'Barème et tarification',
  'federation/clubs': 'Comptes clubs',
  'federation/encaissements': 'Encaissement club',
  'federation/autres-encaissements': 'Autres encaissements',
  'federation/paiements': 'Déclaration du club',
  'federation/decaissements': 'Décaissements',
  'federation/ordres': 'Décaissements',
  'federation/tresorerie': 'Trésorerie',
  'federation/relances': 'Relances',
  'federation/blocage': 'Blocage',
  'club/dashboard': 'Tableau de bord',
  'club/situation': 'Situation financière',
  'club/paiement': 'Payer',
  'club/paiements': 'Paiements',
};

@Component({
  selector: 'app-header',
  standalone: false,
  templateUrl: './header.component.html',
})
export class HeaderComponent implements OnInit, OnDestroy {
  currentUser: User | null = null;
  federationLogoUrl: string | null = null;
  pageTitle = '';

  private destroy$ = new Subject<void>();

  constructor(private authService: AuthService, private router: Router) {}

  ngOnInit(): void {
    this.authService.currentUser$.pipe(takeUntil(this.destroy$)).subscribe(user => {
      this.currentUser = user;
    });

    const fed = this.authService.getFederation();
    if (fed?.logo_url) this.federationLogoUrl = fed.logo_url;

    this.router.events.pipe(
      filter(e => e instanceof NavigationEnd),
      takeUntil(this.destroy$)
    ).subscribe((e: any) => this.resolvePage(e.urlAfterRedirects || e.url));

    this.resolvePage(this.router.url);
  }

  ngOnDestroy(): void { this.destroy$.next(); this.destroy$.complete(); }

  private resolvePage(url: string): void {
    const segments = url.split('?')[0].split('/').filter(Boolean);
    // `espace/section` : les deux premiers segments. Les pages de détail (section/:id) partagent
    // ainsi le nom de leur section.
    const cle = segments.length >= 2 ? `${segments[0]}/${segments[1]}` : '';
    this.pageTitle = PAGE_TITLES[cle] ?? 'Finances';
  }

  logout(): void {
    //  recharge la page : c'est ce qui vide les magasins singletons, que
    // la d�connexion seule laisserait charg�s pour le compte suivant.
    this.authService.logout().subscribe({
      complete: () => this.authService.terminerSession(),
    });
  }
}
